<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">档案导出</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-row >
                    <el-col :span="6">
                        <div  class="shadow">
                            <p><span>老人信息表.xslx</span></p>
                            <el-button type="primary" @click="exportElderlyInfo()">导出数据</el-button>
                        </div>
                    </el-col>
                    <el-col :span="6" v-for="item in list" :key="item.printItemCode">
                        <div  class="shadow">
                            <p><span>{{item.name}}</span><span>{{returnFile(item.url)}}</span></p>
                            <el-button type="primary" @click="openInfo(item.name)">导出数据</el-button>
                        </div>
                    </el-col>
                    
                </el-row>
            </div>
            <div class="modal-footer">
            </div>
         <ExportInfo ref="myExportInfo" v-show="showModalExportInfo" v-on:closeExportInfo="showModalExportInfo=false"></ExportInfo>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import ExportInfo from "./ExportInfo";

    export default {
        name: 'Export',
        data() {
            return {
                loading: false,
                list:null,
                elderlyCode:"",
                showModalExportInfo:false,
            }
        },
        components:{
            ExportInfo
        },
        methods: {

            init(row){
                this.elderlyCode = row.elderlyCode;
               this.getPrintItem();
            },
            getPrintItem(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PrintClass/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.list = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            returnFile(path){
              let pathArr = path.split(".");
                return "."+pathArr[1];
            },
            openInfo(printClassName){
                this.showModalExportInfo=true
                this.$refs.myExportInfo.init(this.elderlyCode,printClassName);
            },

            closeSelf() {
                this.$emit("closeExport");
            },
            closeExportInfo(){
                this.showModalExportInfo=false;
            },
            exportElderlyInfo(){
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var params = new URLSearchParams();
                params.append('timeStr', timeStr);
                params.append('sign', hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
                params.append('staffCode', getStaffCode());
                params.append('elderlyCode', this.elderlyCode);
                this.$axios.get(this.$institutionUrl + 'ImportExcel/ImportElderlyInfo', {
                responseType: 'blob',
                params: params
                }).then(
                    (response) => {
                    loading.close();
                    // this.goodsClassDataShow = !this.goodsClassDataShow;
                    if (response.data.type === 'application/json') {
                        this.$message({type: 'info', message: '暂无数据'});
                    } else {
                        let fileName = '老人信息表.xlsx';
                        this.file(response, fileName);
                    }

                    }
                )
            },
            file(response, fileName) {
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
        }
    }


</script>


<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 2px 2px 20px 1px;
            overflow-x: auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 1200px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }

            .modal-body {
                position: relative;
                padding: 40px;
                z-index: 99;
                overflow-y: auto;
                height: auto;
            }

            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left: 16px;
        width: 56px;
        height: 36px;
        border: none;
        cursor: pointer;
    }

    .btn-close {
        color: #313131;
        background-color: transparent;
    }


    .el-row {
    margin-bottom: 20px;
    text-align: center;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }

  
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

.shadow {
    height: 120px;
    width: 100%;
    border: 1px solid #eee;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    
}
    

</style>
